// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AIModelIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AIModelIcon" ref={forwardedRef} {...props}>
      <path d="M9.346 1.437a1 1 0 0 1 .992-.01l2.417 1.351-1.518.87-1.382-.772-5.368 3.136 5.368 3.135 1.415-.792.735.48v.83l-1.408.787v6.281l5.653-3.16V11.14l1.5-.83v3.554a1 1 0 0 1-.512.873l-6.9 3.859a1 1 0 0 1-.992-.01l-6.6-3.856a1 1 0 0 1-.496-.863V6.155a1 1 0 0 1 .495-.863zM3.75 13.58l5.347 3.124v-6.263L3.75 7.318z" />
      <path d="M15.155 3.219a3 3 0 0 0 2.216 2.37L19 6l-1.629.411a3 3 0 0 0-2.216 2.37L14.75 11l-.405-2.219a3 3 0 0 0-2.216-2.37L10.5 6l1.629-.411a3 3 0 0 0 2.216-2.37L14.75 1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AIModelIcon = /* @__PURE__ */ Object.assign(AIModelIconComponent, {
  displayName: 'AIModelIcon',
});
